/* eslint-disable no-case-declarations */
/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import { UpdateSaleTypes, UpdateSaleState } from './types';

const INITIAL_STATE: UpdateSaleState = {
  update_sale: {
    sale: {
      venda: {
        cliente_id: 0,
        contato_cliente_id: 0,
        created_at: '',
        data_cancelamento: null,
        data_vencimento: '',
        formas_pagamento_id: 0,
        from_site: 0,
        id: 0,
        motivo_cancelamento_id: null,
        observacao: '',
        parcelas: 0,
        recompra: 0,
        renovacao_automatica: 0,
        status_carrinho_id: 0,
        status_id: 0,
        tipo_venda_id: 0,
        updated_at: '',
        usuario_criacao_id: 0,
        usuario_modificacao_id: 0,
        valor_adicional: '',
        valor_base: '',
        valor_desconto_negociacao: '',
        valor_total: '',
        valor_variacao_forma_pagamento: '',
      },
    },
    vigencia_fim: '',
    vigencia_inicio: '',
    services_name: [],
    is_charged: false,
    return_code: null,
  },
  request: {
    loading: false,
    loaded: false,
    error: false,
  },
};
const reducer: Reducer<UpdateSaleState> = (state = INITIAL_STATE, { type, result }) => {
  return produce(state, (draft) => {
    switch (type) {
      case UpdateSaleTypes.GET_UPDATE_SALE_REQUEST:
        draft.request = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case UpdateSaleTypes.GET_UPDATE_SALE_SUCCESS:
        const response = JSON.parse(result.data.body);
        draft.update_sale.vigencia_fim = result.data.vigencia_fim;
        draft.update_sale.vigencia_inicio = result.data.vigencia_inicio;
        draft.update_sale.sale = JSON.parse(result.data.body);
        draft.update_sale.services_name = result.data.services_name;
        draft.update_sale.is_charged = response.is_charged;
        draft.update_sale.return_code = response.return_code;
        draft.request = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case UpdateSaleTypes.GET_UPDATE_SALE_FAILURE:
        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      default:
    }
  });
};
export default reducer;
